import { useMutation } from '@apollo/client/react';
import { VALIDATE_LITMUS_SCHEMA } from '@optools/services/operator-gateway/media-validation/mutations';
import { LitmusValidationSchema } from '@optools/services/operator-gateway/media-validation/types';
import { useState } from 'react';

import { ValidationSuiteFooter } from './validation-suite-footer';
import { ValidationSuiteSelect } from './validation-suite-select';
import { ValidationSuiteTable } from './validation-suite-table';

interface ValidationSuiteProps {
  gamePk: number;
  schemas: LitmusValidationSchema[];
}

export function ValidationSuite({ gamePk, schemas }: ValidationSuiteProps) {
  const [currentSchemaName, setCurrentSchemaName] = useState<string>(
    schemas[0]?.validationProcess ?? '',
  );

  const [validationMutation, { data, loading, reset }] = useMutation(VALIDATE_LITMUS_SCHEMA, {
    fetchPolicy: 'network-only',
  });

  const handleRunValidation = () => {
    if (loading) return;
    validationMutation({ variables: { gamePk, validationProcess: currentSchemaName } });
  };

  const handleChangeSchema = (schemaName: string) => {
    setCurrentSchemaName(schemaName);
    reset();
  };

  const currentSchema = schemas.find((schema) => schema.validationProcess === currentSchemaName);

  return (
    <section>
      <ValidationSuiteSelect
        loading={loading}
        options={schemas}
        value={currentSchemaName}
        onRunValidation={handleRunValidation}
        onValueChange={handleChangeSchema}
      />

      <ValidationSuiteTable loading={loading} result={data?.validate} schema={currentSchema} />

      <ValidationSuiteFooter result={data?.validate} />
    </section>
  );
}
